<template lang="pug">
f7-page#curriculum-creation
  navbar(title="カリキュラム作成")
    template(slot="left")
      f7-link(
        icon="icon-back"
        icon-color="white"
        @click="confirm")

    template(slot="right")
      f7-link(
        :class="{ disabled: !isSubmittable }"
        color="white"
        @click="onSubmit") 登録

  background
    curriculum-form(
      ref="form"
      v-model="isSubmittable")

  saving-action-sheet(
    :opened="actionSheetOpened"
    @actions:closed="actionSheetOpened = false")
</template>

<style lang="scss" scoped>
.background {
  padding-bottom: 40px;
}
</style>

<script>
import PageTitle from '@/components/mixins/PageTitle'
import CurriculumForm from '@/components/organisms/CurriculumForm'
import SavingActionSheet from '@/components/organisms/CurriculumSavingActionSheet'

export default {
  mixins: [PageTitle],
  title: 'カリキュラム作成',
  components: {
    CurriculumForm,
    SavingActionSheet,
  },
  data() {
    return {
      isSubmittable: false,
      actionSheetOpened: false,
    }
  },
  methods: {
    async onSubmit() {
      this.isSubmittable = false
      await this.$refs.form.submit(true)
      this.$f7router.back()
    },
    confirm() {
      if (this.$refs.form.hasChanged) {
        this.actionSheetOpened = true
      } else {
        this.$f7router.back()
      }
    },
  },
}
</script>
